import { Decimal } from "classes/DecimalClasses";

import { i18n } from "services/i18nService";
import { formatDate } from "services/utility/dates";
import {
  formatCompanyWithContactInfo,
  formatBooleanYesOrBlank,
} from "services/utility/formatting";
import { starColumn } from "services/utility/schema";

import { INCH_UNIT, LB_UNIT } from "appConstants";

export const columnInfo = [
  starColumn,
  {
    name: "void",
    buttonLabel: i18n("columns.Void"),
    buttonAction: "void",
    isButton: true,
    fixed: true,
    excludeFromColumnList: true,
  },
  {
    name: "shipmentDate",
    heading: i18n("columns.ShipDate"),
    formatFunc: formatDate,
    defaultSort: true,
    sortDirection: "asc",
    sortable: true,
    fixed: true,
    fixedRightOfAction: true,
  },
  {
    name: "toAddress",
    heading: i18n("columns.To"),
    formatFunc: formatCompanyWithContactInfo,
    fixed: true,
    fixedRightOfAction: true,
    sortable: true,
  },
  {
    name: "fromAddress",
    heading: i18n("columns.From"),
    formatFunc: formatCompanyWithContactInfo,
    fixed: true,
    fixedRightOfAction: true,
    sortable: true,
  },
  {
    name: "shipmentIdentificationNumber",
    heading: i18n("columns.TrackingNumber"),
    sortable: true,
    fixed: true,
    fixedRightOfAction: true,
  },
  {
    name: "totalCharges",
    heading: i18n("columns.TotalCharges"),
    fixed: true,
    fixedRightOfAction: true,
  },
  {
    name: "voided",
    heading: i18n("columns.Voided"),
    formatFunc: formatBooleanYesOrBlank,
    sortable: true,
    fixed: true,
    fixedRightOfAction: true,
  },
];

export const LINE_ACTIONS = ["printLabel", "createReturnUpsShipment"];
export const BATCH_ACTIONS = ["printLabel"];

export const FIELDS_TO_TRANSFORM = {
  DECIMAL_FIELDS: ["weight", "length", "width", "height"],
  MONEY_FIELDS: [],
  DATE_FIELDS: ["shipmentDate"],
  DATETIME_FIELDS: [],
  NON_UTC_DATETIME_FIELDS: [],
};

export function getEmptyRecord() {
  return {
    location: null,
    fromAddress: {
      company: null,
      contact: null,
      address: {
        line1: null,
        line2: null,
        line3: null,
        city: null,
        stateProvince: null,
        postalCode: null,
      },
      phone: null,
      email: null,
    },
    fromResidentialAddress: false,
    toAddress: {
      company: null,
      contact: null,
      address: {
        line1: null,
        line2: null,
        line3: null,
        city: null,
        stateProvince: null,
        postalCode: null,
      },
      phone: null,
      email: null,
    },
    toResidentialAddress: false,
    packagingCode: YOUR_PACKAGING_OPTION.id,
    refNumber: null,
    refNumber2: null,
    returnMerchandiseDescription: null,
    weightUnit: LB_UNIT,
    weight: Decimal.ZERO,
    declaredValue: Decimal.ZERO,
    dimensionUnit: INCH_UNIT,
    length: Decimal.ZERO,
    width: Decimal.ZERO,
    height: Decimal.ZERO,
    serviceCode: null,
    rateType: STANDARD_RATE_OPTION.id,
    deliveryConfirmationCode: STANDARD_CONFIRMATION_OPTION.id,
    saturdayDelivery: false,
    additionalHandling: false,
    upsAccount: null,
  };
}

export const STANDARD_CONFIRMATION_OPTION = {
  id: "0",
  name: i18n("upsShipment.confirmationOption.Standard"),
};
export const CONFIRMATION_OPTIONS = [
  STANDARD_CONFIRMATION_OPTION,
  { id: "1", name: i18n("upsShipment.confirmationOption.Printed") },
  { id: "2", name: i18n("upsShipment.confirmationOption.SignatureRequired") },
  {
    id: "3",
    name: i18n("upsShipment.confirmationOption.AdultSignatureRequired"),
  },
];

export const STANDARD_RATE_OPTION = {
  id: "53",
  name: i18n("upsShipment.rateOption.Standard"),
};
export const RATE_OPTIONS = [
  STANDARD_RATE_OPTION,
  { id: "01", name: i18n("upsShipment.rateOption.Daily") },
  { id: "04", name: i18n("upsShipment.rateOption.Retail") },
];

export const YOUR_PACKAGING_OPTION = {
  id: "02",
  name: i18n("upsShipment.packageOption.YourPackaging"),
};
export const PACKAGE_TYPE_OPTIONS = [
  YOUR_PACKAGING_OPTION,
  { id: "01", name: i18n("upsShipment.packageOption.UPSLetter") },
  { id: "03", name: i18n("upsShipment.packageOption.Tube") },
  { id: "04", name: i18n("upsShipment.packageOption.PAK") },
  { id: "21", name: i18n("upsShipment.packageOption.UPSExpressBox") },
  { id: "30", name: i18n("upsShipment.packageOption.Pallet") },
  { id: "2a", name: i18n("upsShipment.packageOption.SmallExpressBox") },
  { id: "2b", name: i18n("upsShipment.packageOption.MediumExpressBox") },
  { id: "2c", name: i18n("upsShipment.packageOption.LargeExpressBox") },
];
